module.exports = __webpack_public_path__ + "static/media/ToystoresandwichboardsignAshevilleNC2006Enamelonboard.f9b20114.webp";